module.exports = __webpack_public_path__ + "img/INTERIOR-SCROSS-2.b8e7448f.jpg";